<template>
  <section>
    <div class="columns">
      <div class="column is-12 is-paddingless">
        <div class="card events-card">
          <header
            class="card-header"
            style="align-items: center"
          >
            <p class="card-header-title">
              Lien Vault
            </p>
          </header>
          <div class="card-table">
            <div class="content">
              <div class="columns">
                <div
                  id="#app"
                  class="column is-12"
                >
                  <br>

                  <div
                    id="stepEditor"
                    class="timeline"
                  >
                    <header class="timeline-header">
                      <span class="tag is-medium is-success">Start</span>
                    </header>

                    <div id="generatedSteps">
                      <div
                        v-for="(item, index) in info.workflow.workflow"
                        :key="index"
                        class="timeline-item"
                      >
                        <div
                          v-if="info.lien.steps[index].is_executed"
                          class="timeline-marker is-icon is-success"
                        >
                          <i
                            class="fas fa-check fa-fw"
                            aria-hidden="true"
                          />
                        </div>
                        <div
                          v-else-if="info.lien.steps[index].is_active"
                          class="timeline-marker is-icon"
                        />
                        <div
                          v-else
                          class="timeline-marker is-icon is-danger"
                        >
                          <i
                            class="fas fa-ban fa-fw"
                            aria-hidden="true"
                          />
                        </div>
                        <div class="timeline-content">
                          <div class="card">
                            <header class="card-header">
                              <div class="card-header-title">
                                <h4>
                                  <span class="step-title">{{ item.name }}
                                    <div
                                      v-if="info.lien.steps[index].is_executed"
                                      class="tag is-success"
                                    >
                                      <i
                                        class="fas fa-check fa-fw"
                                        aria-hidden="true"
                                      />&nbsp; Done
                                    </div>
                                    <div
                                      v-else-if="info.lien.steps[index].is_active"
                                      class="tag is-light"
                                    >
                                      To do
                                    </div>
                                    <div
                                      v-else
                                      class="tag is-danger"
                                    >
                                      <i
                                        class="fas fa-ban fa-fw"
                                        aria-hidden="true"
                                      />&nbsp; Cancelled
                                    </div>

                                    Date : {{ info.lien.steps[index].execution_date }}
                                  </span>
                                </h4>
                              </div>
                            </header>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="timeline-header">
                      <span class="tag is-medium is-success">End</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import DashboardService from '../../services/dashboard.service';

const dashboardService = new DashboardService();
export default {
  name: 'LienDetails',
  data() {
    return {
      info: {
        renter: {},
        lien: {},
        workflow: {}
      }
    };
  },
  mounted() {
    this.$root.pageTitle = 'Lien Details';
    const self = this;
    dashboardService.getLiens(this.$route.params.uuid)
      .then((response) => {
        const { status, result } = response.data;

        if (status === 'success') {
          self.info = result;
          self.$root.pageTitle += `: ${self.info.renter.firstname} ${self.info.renter.lastname}`;
        } else {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        }
      })
      .catch(() => {
        self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
      });
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-timeline.min.css'></style>
<style scoped>
    .timeline-content {
        width: 100%;
    }

    .timeline .card {
        margin-bottom: .5em;
    }

    .columns {
        height: auto;
    }

    .content h4 {
        margin-bottom: 0;
    }
</style>
